import { render, staticRenderFns } from "./AXpayment.vue?vue&type=template&id=5d062990&scoped=true&"
import script from "./AXpayment.vue?vue&type=script&lang=js&"
export * from "./AXpayment.vue?vue&type=script&lang=js&"
import style0 from "./AXpayment.vue?vue&type=style&index=0&id=5d062990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d062990",
  null
  
)

export default component.exports